import { isNil } from 'lodash';

import { CommunicationTaskQueuePermissions } from '@pwp-common';

import { defaultWorkerPermissions } from '../default-worker-permissions';
import type { WorkerPermissionsEditorOutput } from '../worker-permissions-editor-output';

export const dbToWorkerPermissionsEditorOutput = (
  permissions: CommunicationTaskQueuePermissions,
): WorkerPermissionsEditorOutput | undefined => {
  if (isNil(permissions)) {
    return defaultWorkerPermissions;
  }

  return {
    join: permissions.getJoin(),
  };
};
